<div class="input-group regiao-multiselect">
    <div class="input-group-prepend">
        <button class="btn btn-light" type="button" data-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-cog"></i>
        </button>
        <div class="dropdown-menu">
            <div class="dropdown-item" onclick="event.stopPropagation()">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [ngModel]="somenteAtivas" (ngModelChange)="toggleSomenteAtivas($event)" [name]="nameSomenteAtivas" [id]="idSomenteAtivas">
                    <label class="custom-control-label" [for]="idSomenteAtivas"> Somente Ativas</label>
                </div>
            </div>
        </div>
    </div>
    <div class="input-group-multiselect">
        <ngx-bootstrap-multiselect
            [settings]="settings"
            [texts]="texts"
            [options]="options"
            [(ngModel)]="idsRegioes"
            (ngModelChange)="onChange()"
            [disabled]="disabled">
        </ngx-bootstrap-multiselect>
    </div>
</div>